import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableFilterAddressAutocompleteComponent } from './table-filter-address-autocomplete.component';
import { MaterialModule } from '../../material-components.module';
import { ReactiveFormsModule } from '@angular/forms';
import { LoadingOverlayModule } from '../../loading-overlay/loading-overlay.module';
import { FuryAlertBoxModule } from '../../alert-box/alert-box.module';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    LoadingOverlayModule,
    FuryAlertBoxModule,
  ],
  declarations: [TableFilterAddressAutocompleteComponent],
  exports: [TableFilterAddressAutocompleteComponent],
})

export class TableFilterAddressAutocompleteModule {
}
